import { Alert, Box, Card, CardContent, Typography } from "@mui/material";
import DoughnutChart from "~/components/common/charts/DoughnutChart";
import { VisitTypeColors } from "~/utils/statuses";
import { GetKpiVisitTypesQuery } from "~/graphql/__generated__/graphql";
import { ChartData } from "chart.js";
import SkeletonDoughnutChart from "~/components/common/charts/SkeletonDoughnutChart";

interface Props {
  data?: GetKpiVisitTypesQuery;
  loading: boolean;
}

export const VisitVolumeChart: React.FC<Props> = ({
  loading,
  data
}) => {
  const kpiVisitTypesData = data?.kpiVisitTypes;

  const percentages = kpiVisitTypesData?.visitTypePercentages ?? [];

  const visitVolume = kpiVisitTypesData?.totalVisits;
  const chartData = {
      "labels": Object.keys(percentages),
      "datasets": [
        {
          data: Object.values(percentages),
          backgroundColor: VisitTypeColors,
        }
      ]
  };

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {loading ? <Box sx={{ maxWidth: '80%' }}><SkeletonDoughnutChart title="Visit Volume" /></Box> : (
          (
            !chartData || !chartData?.datasets?.length || visitVolume === 0  ? (
              <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Alert severity="warning" sx={{ width: '100%' }}>
                  No Data
                </Alert>
              </Box>
            ) : (
              <>
                <Typography fontWeight={500}>Visit Volume</Typography>
                <DoughnutChart
                  legendPosition="bottom"
                  data={chartData as ChartData<"doughnut">}
                  centerText={`${visitVolume}`}
                  loading={false}
                />
              </>
            )
          )
          )}
      </CardContent>
    </Card>
  )

}
